import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import selectAppState from 'app/store/selector';
import { Col, Row } from '@guestyci/foundation/esm/Layout';
import TextField from '@guestyci/foundation/TextField';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';
import _extends from '@babel/runtime/helpers/esm/extends';
import imgSource from 'resources/activate-email@1x.png';
import theme from '@guestyci/foundation/theme/defaultTheme';
import AppStyle from 'app/Styles';

const useStyles = createStyles(() =>
  _extends(AppStyle, {
    root: {
      maxWidth: theme.breakpoints.values.lg,
      margin: '0 auto',
    },
    emailTextField: {
      color: '#3B9EFF',
      fontWeight: 100,
      wordBreak: 'break-all',
    },
    emailImg: {
      maxWidth: '50vw',
    },
  }));

const MailSentInfoPage = () => {
  const classes = useStyles();
  const state = useSelector(selectAppState);
  const match = useRouteMatch();

  const email = match.params.email || state.email;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={classes.root} id="email-sent-page-container">
      <Col spacing={9} align="center">
        <Col>
          <TextField align="center" className={classes.pageHeading}>
            We just sent a verification email to:
          </TextField>
          <TextField variant="h2" align="center" className={classes.emailTextField}>
            {email}
          </TextField>
        </Col>

        <Col align="center">
          <img
            className={classes.emailImg}
            src={imgSource}
            id="email-box-image"
            alt="Email box"
          />
        </Col>

        <Row>
          <TextField variant="h3" className="font-weight-light">
            Please click the link in the email to verify your account.
          </TextField>
        </Row>
      </Col>
    </div>
  );
};

export default MailSentInfoPage;
